<template>
  <div :class="['find-your-photos-bar__container', containerModifierClass]">
    <div class="container">
      <div class="row">
        <form
          id="find-my-photos-form"
          :action="siteRoot + 'Home/Search'"
          method="get"
          @submit.prevent="onSubmit"
        >
          <input
            :value="occasionRefValue"
            type="hidden"
            name="occasionRef"
          >
          <input
            :value="lastNameValue"
            type="hidden"
            name="lastName"
          >
          <input
            :value="bibNumberValue"
            type="hidden"
            name="bibNumber"
          >
          <div class="col-sm-9">
            <div class="row">
              <div
                v-if="!hasSelectedOccasionFromServer"
                class="col-sm-6"
              >
                <occasion-typeahead/>
              </div>
              <div :class="participantColumnClass">
                <div class="row">
                  <div
                    v-if="!requiresSecurity"
                    class="find-your-photos-bar__customer-only"
                  >
                    <div class="col-xs-12">
                      <participant-typeahead v-if="!requiresExactMatch"/>
                      <input
                        v-else
                        v-model="participantQuery"
                        :placeholder="localizedStrings.exactMatchPlaceholder"
                        :class="['find-your-photos-bar__input', exactMatchInputClass]"
                      >
                      <div
                        v-if="requiresExactMatch"
                        :class="['find-your-photos-bar__hint', { 'find-your-photos-bar__hint--error': showExactMatchError }]"
                      >
                        <span
                          v-if="showExactMatchError"
                          class="find-your-photos-bar__hint-icon"
                        ><i class="fa fa-exclamation-circle"/></span>
                        {{ localizedStrings.exactMatchHint }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="requiresSecurity"
                    class="find-your-photos-bar__customer-and-postal"
                  >
                    <div class="col-xs-6">
                      <participant-typeahead v-if="!requiresExactMatch"/>
                      <input
                        v-else
                        v-model="participantQuery"
                        :placeholder="localizedStrings.exactMatchPlaceholder"
                        :class="['find-your-photos-bar__input', exactMatchInputClass]"
                      >
                      <div
                        v-if="requiresExactMatch"
                        :class="['find-your-photos-bar__hint', { 'find-your-photos-bar__hint--error': showExactMatchError }]"
                      >
                        <span
                          v-if="showExactMatchError"
                          class="find-your-photos-bar__hint-icon"
                        ><i class="fa fa-exclamation-circle"/></span>
                        {{ localizedStrings.exactMatchHint }}
                      </div>
                    </div>
                    <div class="col-xs-6">
                      <input
                        id="postal-code"
                        v-model="postalCode"
                        :class="postalCodeInputClass"
                        :placeholder="localizedStrings.fieldPostalCode"
                        class="find-your-photos-bar__input"
                        name="postalCode"
                      >
                      <div
                        v-if="showPostalCodeValidation"
                        class="js-postal-code-validation-msg"
                      >
                        <span class="find-your-photos-bar__fail">!</span>
                        <div class="find-your-photos-bar__fail-message">{{ localizedStrings.selectPostalCode }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <button class="button button--cta button--fw find-your-photos-bar__button">
              <template v-if="occasionHasHappened">
                {{ localizedStrings.find }}
                <span class="hidden-sm">{{ localizedStrings.linkMyPhotos }}</span>
                <div class="button__image button__image--arrow-right"/>
              </template>
              <template v-else>
                {{ localizedStrings.shop }}
                <div class="button__image button__image--arrow-right"/>
              </template>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import OccasionTypeahead from './components/OccasionTypeahead.vue'
import ParticipantTypeahead from './components/ParticipantTypeahead.vue'

export default {
  name: 'FindMyPhotosApp',
  components: {
    OccasionTypeahead: OccasionTypeahead,
    ParticipantTypeahead: ParticipantTypeahead
  },
  data: function () {
    return {
      lastNameValue: '',
      bibNumberValue: ''
    }
  },
  computed: {
    siteRoot: function () {
      return this.$store.state.siteRoot
    },
    localizedStrings: function () {
      return this.$store.state.localizedStrings
    },
    hasSelectedOccasionFromServer: function () {
      return this.$store.getters.hasSelectedOccasionFromServer
    },
    requiresSecurity: function () {
      return this.$store.getters.requiresSecurity
    },
    requiresExactMatch: function () {
      return this.$store.getters.requiresExactMatch
    },
    participantQuery: {
      get: function () {
        return this.$store.state.participantQuery
      },
      set: function (value) {
        this.$store.commit('setParticipantQuery', value)
      }
    },
    occasionHasHappened: function () {
      return this.$store.getters.occasionHasHappened
    },
    occasionRefValue: function () {
      var selected = this.$store.state.selectedOccasion
      return selected ? selected.occasionRef : ''
    },
    postalCode: {
      get: function () {
        return this.$store.state.postalCode
      },
      set: function (value) {
        this.$store.commit('setPostalCode', value)
      }
    },
    containerModifierClass: function () {
      return this.hasSelectedOccasionFromServer ? 'find-your-photos-bar__container--no-margin' : ''
    },
    participantColumnClass: function () {
      return this.hasSelectedOccasionFromServer ? 'col-sm-12' : 'col-sm-6'
    },
    showPostalCodeValidation: function () {
      return this.$store.state.validationAttempted && !this.$store.getters.postalCodeValid
    },
    postalCodeInputClass: function () {
      if (!this.$store.state.validationAttempted) {
        return ''
      }
      return this.$store.getters.postalCodeValid
        ? 'find-your-photos-bar__input--success'
        : 'find-your-photos-bar__input--fail'
    },
    showExactMatchError: function () {
      return this.$store.state.validationAttempted && !this.$store.getters.exactMatchInputValid
    },
    exactMatchInputClass: function () {
      if (!this.$store.state.validationAttempted) {
        return ''
      }
      return this.$store.getters.exactMatchInputValid ? '' : 'find-your-photos-bar__input--fail'
    }
  },
  methods: {
    onSubmit: function () {
      this.$store.commit('setValidationAttempted', true)

      // Apply bib-vs-lastname heuristic if no participant was selected from dropdown
      this.lastNameValue = ''
      this.bibNumberValue = ''

      if (this.$store.state.selectedParticipant) {
        this.lastNameValue = this.$store.state.selectedParticipant.ln
        this.bibNumberValue = this.$store.state.selectedParticipant.bn
      } else {
        var participantInput = this.$store.state.participantQuery
        var bibNumRegEx = /^[0-9]+/
        if (bibNumRegEx.test(participantInput)) {
          this.bibNumberValue = participantInput
        } else {
          this.lastNameValue = participantInput
        }
      }

      if (!this.$store.getters.formValid) {
        return
      }

      // GA tracking
      if (typeof window.gaToAllTrackers === 'function') {
        window.gaToAllTrackers('send', {
          hitType: 'event',
          eventCategory: 'Search',
          eventAction: 'Searched',
          eventLabel: 'Event Name, Last Name or Bib Number'
        })
      }

      // Build search URL and navigate
      var params = []
      params.push('occasionRef=' + encodeURIComponent(this.occasionRefValue))
      if (this.lastNameValue) {
        params.push('lastName=' + encodeURIComponent(this.lastNameValue))
      }
      if (this.bibNumberValue) {
        params.push('bibNumber=' + encodeURIComponent(this.bibNumberValue))
      }
      if (this.requiresSecurity && this.postalCode) {
        params.push('postalCode=' + encodeURIComponent(this.postalCode))
      }

      window.location.href = this.siteRoot + 'Home/Search?' + params.join('&')
    }
  }
}
</script>



// WEBPACK FOOTER //
// WebResources/vue/find-my-photos/App.vue